/**
 * Enveloppes de réponse, d'erreur, de pagination et de filtre.
 * Référence : document 06 § 2.4, § 2.5 et § 2.6.
 */
/** Codes d'erreur métier contractuels (document 06 § 2.5). */
export const API_ERROR_CODES = {
    validationError: 'VALIDATION_ERROR',
    resourceNotFound: 'RESOURCE_NOT_FOUND',
    resourceConflict: 'RESOURCE_CONFLICT',
    uniquenessViolation: 'UNIQUENESS_VIOLATION',
    authInvalidCredentials: 'AUTH_INVALID_CREDENTIALS',
    authEmailNotVerified: 'AUTH_EMAIL_NOT_VERIFIED',
    authMfaRequired: 'AUTH_MFA_REQUIRED',
    authMfaInvalid: 'AUTH_MFA_INVALID',
    authAccountLocked: 'AUTH_ACCOUNT_LOCKED',
    authTokenExpired: 'AUTH_TOKEN_EXPIRED',
    authRefreshReuse: 'AUTH_REFRESH_REUSE',
    authzPermissionDenied: 'AUTHZ_PERMISSION_DENIED',
    tenantAccessDenied: 'TENANT_ACCESS_DENIED',
    tenantSuspended: 'TENANT_SUSPENDED',
    featureDisabled: 'FEATURE_DISABLED',
    planQuotaExceeded: 'PLAN_QUOTA_EXCEEDED',
    invalidStateTransition: 'INVALID_STATE_TRANSITION',
    rateLimitExceeded: 'RATE_LIMIT_EXCEEDED',
    providerUnavailable: 'PROVIDER_UNAVAILABLE',
    internalError: 'INTERNAL_ERROR',
};
//# sourceMappingURL=api.types.js.map